import React, { useState, useRef } from "react";
import { Switch, Tooltip } from "@mui/material";
import { callAPI } from "../../../axios";
import BasicModal from "../../core/BaseComponents/Modal";

const EnableDisableUtilityConfig = (props) => {

  const [modal, setShowModal] = useState(false);

  const isRoomTypeEnableModalRef = useRef({
    isRoomTypeConfirmationModalData: null,
    roomTypeConformationModalData: null,
  });

  const handleToggleChange = (e, row) => {
    const sid = row.id;
    const { name, value } = e.target;
    const isEnabled = value !== "true";
    setShowModal(true);
    const newModalRefData = {
      isRoomTypeConfirmationModalData: {
        sid,
        isEnabled,
      },
      roomTypeConformationModalData: null,
    };
    isRoomTypeEnableModalRef.current = newModalRefData;
  };

  const enabledTrue = () => {
    const { sid, isEnabled } =
      isRoomTypeEnableModalRef.current?.isRoomTypeConfirmationModalData;
    props.setLoader(true);
    callAPI(`/enable_utility?id=${sid}&active=${isEnabled}`, "PUT")
      .then(() => {
        props.setLoader(false);
        const newModalRefData = {
          isRoomTypeConfirmationModalData: null,
          roomTypeConformationModalData: {
            userIsEnabled: isEnabled,
          },
        };
        isRoomTypeEnableModalRef.current = newModalRefData;
        props?.utilityListApi();
      })
      .catch((error) => {
        props.setLoader(false);
        console.warn(error)
      });
  };

  return (
    <>
      <Tooltip title={props?.row.active ? "Active" : "Inactive"} arrow>
        <Switch
          name="active"
          onChange={(event) => handleToggleChange(event, props?.row)}
          inputProps={{ "aria-label": "controlled" }}
          value={props?.row.active}
          checked={props?.row.active}
          className={`${props?.row.active === false ? 'switchuser-inactive' : 'switchuser-active'}`}
        />
      </Tooltip>
      <BasicModal
        popupOpen={modal}
        footer={
          isRoomTypeEnableModalRef.current?.isRoomTypeConfirmationModalData
            ? {
              primaryButton: {
                action: () => setShowModal(false),
                buttonName: "Cancel",
              },
              secondaryButton: {
                action: enabledTrue,
                buttonName: "Yes",
              },
            }
            : {
              secondaryButton: {
                action: () => setShowModal(false),
                buttonName: "OK",
              },
            }
        }
        bodyMessage={
          <>
            {isRoomTypeEnableModalRef.current?.isRoomTypeConfirmationModalData && (
              <div className="pop-up-design">
                {isRoomTypeEnableModalRef.current?.isRoomTypeConfirmationModalData?.isEnabled ? <img className="mb-2 image-enable-disble" src='/Images/enabled.png' /> : <img className="mb-2 image-enable-disble" src='/Images/disabled.png' />}
                <p>
                  Do you really want to
                  {isRoomTypeEnableModalRef.current?.isRoomTypeConfirmationModalData
                    ?.isEnabled
                    ? " Enable "
                    : " Disable "}
                  this Utility Configuration ?
                </p>
              </div>
            )}
            {isRoomTypeEnableModalRef.current?.roomTypeConformationModalData && (
              <div>
                <span className='d-block'><img src='/Images/approve-qc.png' className="image-enable-disble" /></span>
                <p className="enable mt-3">
                  Successfully
                  {isRoomTypeEnableModalRef.current?.roomTypeConformationModalData
                    ?.userIsEnabled
                    ? " Enabled "
                    : " Disabled "}!
                </p>
              </div>
            )}
          </>
        }
      />
    </>
  )
}

export default EnableDisableUtilityConfig;